import { render, staticRenderFns } from "./AcoesSolicitarEnvioDocumento.vue?vue&type=template&id=4e384beb&scoped=true"
import script from "./AcoesSolicitarEnvioDocumento.vue?vue&type=script&lang=js"
export * from "./AcoesSolicitarEnvioDocumento.vue?vue&type=script&lang=js"
import style0 from "./AcoesSolicitarEnvioDocumento.vue?vue&type=style&index=0&id=4e384beb&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e384beb",
  null
  
)

export default component.exports